<template>
  <ChartCustom :chart-settings="chartConfig" :dimensions="dimensions"></ChartCustom>
</template>

<script>
  import lodash from 'lodash';
  import ChartCustom from '../../../general/ChartCustom.vue';
  import DataMethods from '../../../utils/DataMethods';

  export default {
    name: 'LocationSummaryLegend',
    mixins: [DataMethods],
    components: {
      ChartCustom,
    },
    props: ['location', 'max', 'min'],
    computed: {
      unitTypes() {
        return [
          'premium_units',
          'advanced_units',
          'basic_units',
          'entry_units',
          'access_units',
          'cros_units',
        ]
      },
      dimensions() {
        return {
          height: 320,
        };
      },
      formattedData() {
        return [{
          ...this.location.totals,
          name: this.location.name,
          abs_units: lodash.reduce(this.location.totals, (sum, total, key) => {
            return this.unitTypes.includes(key) ? sum +  Math.abs(total) : sum;
          }, 0)
        }];
      },
      chartConfig() {
        const formattedData = this.formattedData;
        const self = this;
        return {
          size: {
            height: 350,
          },
          data: {
            json: formattedData,
            type: 'bar',
            labels: {
              format: function(v, id, i, j) {
                if (v > 0 && id != undefined) {
                  if (id != undefined) {
                    let percRaw = parseInt(v) / (parseInt(formattedData[i]['abs_units']) || 1);
                    let perc = self.round(percRaw * 100);
                    return perc+'%';
                  }
                  return v;
                }
                return '';
              }
            },
            names: {
              premium_units: 'Premium',
              advanced_units: 'Advanced',
              basic_units: 'Basic',
              entry_units: 'Entry',
              access_units: 'Access',
              cros_units: 'CROS',
              otc_units: 'OTC',
            },
            keys: {
              x: 'name',
              value: this.unitTypes.reverse(),
            },
            groups: [
              this.unitTypes.reverse(),
            ],
            colors: {
              premium_units: '#1EAEFF',
              advanced_units: '#80BD4D',
              basic_units: '#D87E00',
              entry_units: '#E9CA1E',
              access_units: '#F8076E',
              cros_units: '#1B75BB'
            },
            order: null,
          },
          axis: {
            x: {
              type: 'category',
              show: false,
            },
            y: {
              show: true,
              max: parseInt(this.max),
              min: parseInt(this.min),
            },
            y2: {
              show: false
            },
          },
          bar: {
            space: 0.3,
            width: 0
          },
          legend: {
            show: false,
            position: 'inset',
            inset: {
              anchor: 'top-left',
              x: 0,
              y: -65,
              step: 2
            },
            hide: ['units']
          },
          tooltip: {
            show: false,
          },
        };
      }
    },
  };
</script>
